import classNames from 'classnames';
import { Colors } from '@vds/core';
import { Icon, IconName } from '@components/icon';
import { Stack } from '@components/layout';
import { Body } from '@components/text';

export interface ListItemProps {
  /** the name of the icon to display */
  icon?: IconName;
  /** controls the size of the label (icon stay same size) */
  size?: 'small' | 'large';
  /** the label string to display */
  label?: string;
  /** alternative (or addition) to label if string is not sufficient */
  children?: React.ReactNode;
  className?: string;
}

/**
 * ListItem component
 * @param icon - the name of the icon to display
 * @param size - controls the size of the label (icon stay same size). default large
 * @param label - the label string to display
 * @param children - alternative (or addition) to label if string is not sufficient
 * @param className - additional classNames for the component
 */

export const ListItem: React.FC<ListItemProps> = ({
  icon = 'checkmark',
  size = 'large',
  label = '',
  className,
  children,
  ...rest
}) => (
  <Stack
    alignItems="center"
    gap="spacing-small"
    flexDirection="row"
    className={classNames('vds-list-item', className)}
    {...rest}>
    <Icon name={icon} color={Colors.Brand.Primary} size="small" />
    <Body variant="body-02" size={size === 'small' ? 'medium' : 'large'} weight="regular">
      {label}
      {children}
    </Body>
  </Stack>
);
